import { FC, useEffect } from "react";

import {TableContainer,Table,TableHead,TableRow,TableCell,TableBody} from '@mui/material'
import {Controller,Control} from "react-hook-form";
import { DateTimePicker} from "@mui/x-date-pickers";
import {FieldArrayWithId} from "react-hook-form/dist/types/fieldArray";
import { useTranslation } from "react-i18next";
import {TextField} from '@mui/material'

interface RenewalItemsProps {
    fields:FieldArrayWithId[],
    control: Control<any>,
    formState:any
}

export const Renewaltems:FC<RenewalItemsProps> = ({fields,control,formState}) => {
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'voucher'});

    return  <>
        {fields && fields.length > 0 &&
        <TableContainer sx={{paddingTop: "10px"}}>
            <Table aria-label="subPeriods-table">
                <TableHead>
                    <TableRow>
                        <TableCell>{t('inputUpdatePageFields.renewalsSection.renewalDate')}</TableCell>
                        <TableCell>{t('inputUpdatePageFields.renewalsSection.note')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {fields.map((item:any, index: number) => (
                        <TableRow
                            key={"renewalItem" + index}
                        >
                            <TableCell>
                                <Controller
                                    control={control}
                                    name={`renewalsList.${index}.renewalDate`}
                                    render={({field}) => (
                                        <DateTimePicker
                                            disabled
                                            onChange={field.onChange}
                                            value={field.value}
                                            ampm={false}
                                            renderInput={(params) =>
                                                <TextField
                                                    required
                                                    {...params}
                                                    style={{width: "50%"}}
                                                    fullWidth
                                                    name="renewalDate"
                                                />}
                                            inputFormat={"DD/MM/YYYY HH:mm"}
                                        />
                                    )}
                                />
                            </TableCell>
                            <TableCell>
                                <Controller
                                    control={control}
                                    name={`renewalsList.${index}.note`}
                                    render={({field, fieldState}) => (
                                            <TextField
                                            style={{width: "50%"}}
                                            fullWidth
                                            name="note"
                                            onChange={field.onChange}
                                            value={field.value}
                                            error={!!formState.error}
                                            helperText={fieldState.error?.message}

                                        />
                                    )}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>}
    </>
    
}